/* globals window */
import { Component } from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';

import addTooltip from '../../../lib/AddTooltip';
import styles from './Dropdowns.scss';

export default class DropdownBase extends Component {
    static propTypes = {
        widgetId: PropTypes.string,
        type: PropTypes.string,
        color: PropTypes.string,
        prefixText: PropTypes.string,
        onSelectedValue: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    };

    static defaultProps = {
        type: '',
        widgetId: '',
        onSelectedValue: () => {},
        color: null,
        prefixText: '',
    };

    constructor(props) {
        super(props);

        this.state = {
            isDropdownEnabled: false,
        };
    }

    componentDidMount() {
        const { prefixText } = this.props;
        if (prefixText) this.calculatePrefixTextLength();
    }

    componentDidUpdate() {
        if (this.dropdownInput) {
            addTooltip(this.dropdownInput);
        }

        if (this.state.isDropdownEnabled && this.addListElemTooltips) {
            this.addListElemTooltips();
        }
    }

    componentWillUnmount() {
        this.closeDropdownMenu();
    }

    onItemClick = listElemid => () => this.props.onSelectedValue && this.props.onSelectedValue(this.props.widgetId, listElemid);

    getInputClass(selection) {
        const { isDropdownEnabled } = this.state;
        const { color } = this.props;
        let inputClass = 'dropdown-input';

        if (!selection.length) {
            inputClass = 'dropdown-input-placeholder';
        }

        if (isDropdownEnabled) {
            inputClass += '-opened';
        }

        if (color) {
            inputClass += `-${color}`;
        }

        return inputClass;
    }

    getWidgetProps() {
        const widgetProps = omit(this.props, [
            'datepickerOptions',
            'selectedValue',
            'selectedValues',
            'onSelectedValue',
            'list',
            'type',
            'color',
            'placeholder',
            'styleName',
            'styles',
            'widgetId',
            'prefixText',
        ]);

        if (this.props.type) {
            widgetProps.className = styles[`dropdown-${this.props.type}`];
        }

        return widgetProps;
    }

    openDropdownMenu() {
        if (!this.state.isDropdownEnabled) {
            this.setState({ isDropdownEnabled: true });
            setTimeout(() => window.addEventListener('click', this.closeDropdownMenu), 1);
        }
    }

    closeDropdownMenu = (e) => {
        const closeDropdownMenu = () => {
            window.removeEventListener('click', this.closeDropdownMenu);
            this.setState({ isDropdownEnabled: false });
        };

        if (this.shouldCloseDropdownMenu && e) {
            if (this.shouldCloseDropdownMenu(e)) {
                closeDropdownMenu();
            }
        } else {
            closeDropdownMenu();
        }
    };

    calculatePrefixTextLength = () => {
        const DEFAULT_LEFT_PADDING = 15;
        const { prefixText } = this.props;
        const $testElem = $('<div />');

        $testElem
            .css({ visibility: 'hidden', display: 'inline-block', fontSize: '12px' })
            .text(`${prefixText}\u00A0`)
            .appendTo('body');

        if (this.dropdownInput) {
            $(this.dropdownInput).css({ paddingLeft: DEFAULT_LEFT_PADDING + $testElem.width() });
        }

        $testElem.remove();
    };
}
